import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteNav } from "./components/SiteNav";
import { SiteFooter } from "./components/SiteFooter";
import { Home } from "./pages/Home";
import { Wholesale } from "./pages/Wholesale";
import { Investors } from "./pages/Investors";
import { Manufacturing } from "./pages/Manufacturing";
import { FourthwallSnippet } from "./pages/FourthwallSnippet";
type AppProps = {
  launchSeries?: "robot" | "trash-punks" | "goth-girls";
};
export function App({
  launchSeries = "robot"
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="2mjzplczyq3q9">
      <div className="flex min-h-screen w-full flex-col bg-paper font-sans text-ink" data-id="element-1" data-mp="31b8jhyaweb97">
        <SiteNav data-id="element-2" data-mp="2wk06ksad07ra" />
        <main className="flex-1" data-id="element-3" data-mp="2wjgtppzkg9k4">
          <Routes data-id="element-4" data-mp="2wifgbev2vaz8">
            <Route path="/" element={<Home launchSeries={launchSeries} data-id="element-6" data-mp="28u5y0mx2p5cu" />} data-id="element-5" data-mp="2whxbhtucnofp" />
            <Route path="/wholesale" element={<Wholesale data-id="element-8" data-mp="28s2z1ddy01vz" />} data-id="element-7" data-mp="28sutgkvsztko" />
            {/* Unlisted: shared by direct link only */}
            <Route path="/investors" element={<Investors data-id="element-10" data-mp="3ik7k0rkruvvx" />} data-id="element-9" data-mp="23t8fuac2cbbc" />
            <Route path="/team/manufacturing" element={<Manufacturing data-id="element-12" data-mp="3ii4su47vuwpm" />} data-id="element-11" data-mp="3iiwaeb4natww" />
            <Route path="/team/fourthwall" element={<FourthwallSnippet data-id="element-14" data-mp="3mjzu58ptda3e" />} data-id="element-13" data-mp="3ml12v6jcxkhy" />
            <Route path="*" element={<Home launchSeries={launchSeries} data-id="element-16" data-mp="3rbrcivytg9ig" />} data-id="element-15" data-mp="3rc9e8848zfxr" />
          </Routes>
        </main>
        <SiteFooter data-id="element-17" data-mp="5ott78p769p" />
      </div>
    </BrowserRouter>;
}